import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import MainPagetitle from '../../../layouts/MainPagetitle';
import GrievanceSearch from './components/GrievanceSearch/GrievanceSearch';
import GrievanceStatsCard from './components/GrievanceStatsCard';

const Grievance = (props) => {
  const navigate = useNavigate();
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
  });
  const [rowcount, setRowcount] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [columns, setColumns] = useState([
    {
      dataIndex: 'customerName',
      title: 'Customer Name',
      render: (text, record) => {
        return (
          <div>
            <h6 className="text-primary">{record?.customerName}</h6>
            <span>{record?.applicationId}</span>
          </div>
        );
      },
    },
    {
      dataIndex: 'mobileNumber',
      title: 'Phone No.',
    },
    {
      dataIndex: 'applicationLoanAccount',
      title: 'LAN',
      render: (text, record) => {
        return <>{record?.applicationLoanAccount?.loanAccountNumber || '-'}</>;
      },
    },
    {
      dataIndex: 'classification',
      title: 'Classification',
    },
    {
      dataIndex: 'channel',
      title: 'Channel',
    },
    {
      dataIndex: 'raisedOn',
      title: 'Raised On',
      render: (text, record) => {
        let date = record?.raisedOn;
        if (date) {
          let formattedDate = new Date(date).dateToDDMMYYYY(new Date(date));
          return formattedDate || '-';
        } else {
          return '-';
        }
      },
    },
    {
      dataIndex: 'status',
      title: 'Application Status',
      render: (text, record) => {
        let mappedStatus = _enum.STATUS_COLOR_MAP[record?.status?.toLowerCase()] || '';
        return (
          <Dropdown className="status-dropdown no-arrow pe-none">
            <Dropdown.Toggle as="div" className={mappedStatus}>
              <span>{record?.status?.toTitleCase()}</span>
              <i className="fa-solid fa-chevron-down ms-2"></i>
            </Dropdown.Toggle>
          </Dropdown>
        );
      },
    },
  ]);

  const onPageChange = (pageData) => {
    // console.log({ onPageChange: pageData });
    setSearch({
      page: pageData.current,
      limit: pageData.pageSize || pageData.defaultPageSize || 25,
    });
  };

  const onSearch = (data, reset) => {
    console.log('onSearch on grievance', data, reset);
    let defaultSearchData = Object.only(data, ['limit', 'page']);
    let payload;
    if (reset) {
      payload = {
        ...defaultSearchData,
      };
      //   getGrievanceData(payload, reset);
    } else {
      payload = {
        ...data,
        page: 1,
        limit: 10,
      };
      //   getGrievanceData(payload, reset);
    }
    setSearch(payload);
  };

  const getGrievanceData = (params = {}, reset) => {
    // let payload = {
    //   ...params,
    // };
    // const hasAnyValue = Object.values(payload).some((value) => value !== "");
    // if (!hasAnyValue || reset) {
    //   return;
    // } else {
    //   props.apis.apiGetGrievance(payload).then((res) => {
    //     setTableData(res);
    //     setRowcount(0);
    //   });
    // }

    // MOKE DATA
    setTableData([
      {
        customerName: 'Anshita Goel',
        mobileNumber: '+91 9876543210',
        applicationLoanAccount: {
          loanAccountNumber: 'AFI-1234',
        },
        classification: 'General',
        channel: 'Website',
        raisedOn: new Date(),
        status: 'IN_PROGRESS',
      },
    ]);
  };

  useEffect(() => {
    // scroll page to top
    window.scrollTo(0, 0);
    getGrievanceData();
  }, []);

  const view = (record) => {
    console.log({ record });
    let { applicationId } = record;
    let path = `/app/grievanceview?id=${applicationId}&frompath=grievance&type=general`;
    navigate(path);
  };

  return (
    <>
      <MainPagetitle
        mainTitle="Grievance"
        parentTitle={'Home'}
        pageIcon={imagepaths.GrievanceIconActive}
      />
      <div className="container-fluid">
        <GrievanceStatsCard />
        <div className="row">
          <div className="col-xl-12">
            <div className="card border-0">
              <div className="card-body p-0">
                <div className="tbl-caption-container justify-content-end">
                  <div className="header_btn_box my-3">
                    <a className="btn btn-sm btn-outline-secondary me-2">
                      <i className="fa fa-download me-2"></i>
                      <span>Bulk Download</span>
                    </a>
                  </div>
                  <GrievanceSearch onSearch={(...arg) => onSearch(...arg)} />
                </div>
                <AppTable
                  data={tableData}
                  columns={columns}
                  onChange={(...arg) => onPageChange(...arg)}
                  total={rowcount}
                  reorder={true}
                  viewAction={(e) => view(e)}
                  editable={false}
                  deletable={false}
                ></AppTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(Grievance);
